import React, { HTMLAttributes } from 'react';

interface CardActionsProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const CardActions = ({ className, children, ...props }: CardActionsProps): JSX.Element => {
  return (
    <div className={className} {...props} data-testid="cardactions-test">
      {children}
    </div>
  );
};

export default CardActions;
